const NAMESPACE = "conditionsCapsule";

const KEYS = {
    conditionsCapsuleEmptyText: "conditionsCapsuleEmptyText",
    conditionsTableDescriptionColumnHeader: "conditionsTableDescriptionColumnHeader",
    conditionsTableActionsColumnHeader: "conditionsTableActionsColumnHeader",
    modifyConditionButtonText: "modifyConditionButtonText",
    removeConditionButtonText: "removeConditionButtonText",
    addConditionButtonText: "addConditionButtonText",
    addConditionDialogTitle: "addConditionDialogTitle",
    modifyConditionDialogTitle: "modifyConditionDialogTitle",
    editConditionCancelButtonText: "editConditionCancelButtonText",
    editConditionSaveButtonText: "editConditionSaveButtonText",
    multipleChoiceOrJoiner: "multipleChoiceOrJoiner",
    multipleChoiceAndJoiner: "multipleChoiceAndJoiner",
    removeConditionConfirmText: "removeConditionConfirmText",
    falseValue: "falseValue",
    trueValue: "trueValue"
};

const MESSAGES = {
    [KEYS.conditionsCapsuleEmptyText]: {
        value: "There are no eligibility conditions",
        comment: "Text displayed if no eligibility conditions have been defined"
    },
    [KEYS.conditionsTableDescriptionColumnHeader]: {
        value: "Condition",
        comment: "Header for the Description column of the Conditions table"
    },
    [KEYS.conditionsTableActionsColumnHeader]: {
        value: " ",
        comment: "Header for the Actions column of the Conditions table; the header may be blank"
    },
    [KEYS.modifyConditionButtonText]: {
        value: "Modify",
        comment: "Text for the Modify Condition link"
    },
    [KEYS.removeConditionButtonText]: {
        value: "Remove",
        comment: "Text for the Remove Condition link"
    },
    [KEYS.addConditionButtonText]: {
        value: "Add Condition",
        comment: "Text for the Add Condition button"
    },
    [KEYS.addConditionDialogTitle]: {
        value: "Add Eligibility Condition",
        comment: "Title of the Add Eligibility Condition dialog"
    },
    [KEYS.modifyConditionDialogTitle]: {
        value: "Modify Eligibility Condition",
        comment: "Title of the Modify Eligibility Condition dialog"
    },
    [KEYS.editConditionCancelButtonText]: {
        value: "Cancel",
        comment: "Text for the Cancel button"
    },
    [KEYS.editConditionSaveButtonText]: {
        value: "Save",
        comment: "Text for the Save button"
    },
    [KEYS.multipleChoiceOrJoiner]: {
        value: " OR ",
        comment: "Text for the boolean OR joiner of multiple choice selections"
    },
    [KEYS.multipleChoiceAndJoiner]: {
        value: " AND ",
        comment: "Text for the boolean AND joiner of multiple choice selections"
    },
    [KEYS.removeConditionConfirmText]: {
        value: "Are you sure you wish to remove this condition?",
        comment: "Prompt to confirm that a condition should be removed"
    },
    [KEYS.falseValue]: {
        value: "false",
        comment: "Text for displaying the value 'false'"
    },
    [KEYS.trueValue]: {
        value: "true",
        comment: "Text for displaying the value 'true'"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
